// js
import { connect } from 'react-redux';
import SourcesStackItem from '../../components/sources/SourcesStackItem';
import { makeGetIsActiveArea } from '../../selectors/dsa/areaSelectors';
import { makeGetSubAreaSourcesProgress, makeGetAreaSourcesStats, makeGetSubAreaSourcesStats } from '../../selectors/dsa/sourcesSelectors';


const mapStateToProps = (state, props) => {
  const getIsActiveArea = makeGetIsActiveArea();
  const getAreaSourcesStats = makeGetAreaSourcesStats();
  const getSubAreaSourcesProgress = makeGetSubAreaSourcesProgress();
  const getSubAreaSourcesStats = makeGetSubAreaSourcesStats();

  return {
    isActiveArea: getIsActiveArea(state, props),
    progress: getSubAreaSourcesProgress(state, props),
    areaStats: getAreaSourcesStats(state, props),
    stats: getSubAreaSourcesStats(state, props)
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SourcesStackItem);



// WEBPACK FOOTER //
// ./src/containers/sources/SourcesStackItem.js